import Marquee from "react-fast-marquee";
import { BRAND } from "@/lib/data";

export const StripMarquee = () => {
  const word = BRAND.mission.toUpperCase();
  return (
    <section data-testid="marquee" className="border-y border-[#1a1a1a] bg-[#050505] py-8 md:py-10">
      <Marquee speed={55} gradient={false} autoFill>
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase text-[8vw] md:text-[5vw] leading-none stroke-text px-8">
              {word}
            </span>
            <span className="text-green text-[8vw] md:text-[5vw] leading-none px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
